import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Contacto, TipoContacto } from '../../../../interfaces/contacto';
import { MatTableDataSource, MatSort } from '@angular/material';
import { PermisoService } from '../../../../providers/permiso.service';
import { Telefono } from '../../../../components/telefono/telefono.component';
import { Entidad } from '../../../../interfaces/entidad';

@Component({
  selector: 'app-listar-contactos',
  templateUrl: './listar-contactos.component.html',
  styleUrls: ['./listar-contactos.component.scss']
})
export class ListarContactosComponent implements OnInit {
  tablaContactosColumnas = ['nombre', 'tipoContacto', 'email', 'celular', 'telefono', 'interno'];
  contactosDataSource = new MatTableDataSource();
  contactos: Contacto[] = <Contacto[]>[];
  @Input() acciones: boolean = false; // true para mostrar las acciones de ABM etc...
  @Input() cargando: boolean = false; // true para mostrar el progres var.
  @Input() conFiltro: boolean = false; // mostrar u ocultar el input de filtros.
  @Input() conSort: boolean = false; // mostrar u ocultar el sort en la columna.
  @Output() onChange = new EventEmitter();
  @Input() entidadRazonSocial: string; // traigo la razon social de la entidad.
  private sort: MatSort; // objeto sort para ordenar las columnas de la tabla
  @ViewChild(MatSort) set contentSort(content: MatSort) {
    this.sort = content;
    
    // set MatSort después de que todas las directivas (*ngIf etc..) se activaron
    this.contactosDataSource.sort = this.sort;
   // console.log(this.contactosDataSource.sort,'putodata');
  }

  constructor(
    private permisoService: PermisoService
  ) { }

  ngOnInit() {
    if (this.acciones) { // si solicitan mostrar acciones
      this.permisoService.tienePermiso('PROSPECTO-ACCIONES').then(tienePermiso => { // si tiene permiso
        if (tienePermiso) {
          this.tablaContactosColumnas.push('acciones');
        }
      });
    } else {
      this.tablaContactosColumnas.push('accesos');
    }
 ;
  

    // modificar la función de filtro default (de MatTable) para que pueda trabajar con los objetos que usamos
    // data: todos los datos de la tabla que deben ser filtrados
    // filtro: valor del filtro que ingresa el usuario
    this.contactosDataSource.filterPredicate = (data: any, filtro: string) => {
      var flag_filtro_ok = false; // false si el filtro no fue encontrado en el data
      var flattenData = this.flattenObject(data); // traer el data como un objeto plano
      var arrayDataValues = Object.values(flattenData); // obtener los valores del objeto como array
      arrayDataValues.forEach(value => { // revisar si el filtro buscado esta contenido en cualquier valor del data
        if (!flag_filtro_ok) {
          flag_filtro_ok = (value || '').toString().trim().toLowerCase().indexOf(filtro) !== -1; // true si el filtro fue encontrado
          return;
        }
      });

      return flag_filtro_ok;
    };

    // modificar la función de sort default (de MatTable) para que pueda trabajar con los objetos que usamos
    // data: todos los datos de la tabla que deben ser ordenados
    // sort: objeto con parametros para saber por que columna/direccion..etc debemos ordenar
    this.contactosDataSource.sortData = (data, sort: MatSort) => {
      if (sort.active) { // si hay un campo activo para ordenar
        switch (sort.active) {
          case 'tipoContacto': // hacer un 'case' para cada sort que requiera una funcion especial
            return data.sort(function (a, b) {
              return (sort.direction == "asc" ? 1 : -1) * ((a[sort.active].tipoContactoDesc > b[sort.active].tipoContactoDesc) ? 1 : ((b[sort.active].tipoContactoDesc > a[sort.active].tipoContactoDesc) ? -1 : 0));
            });
          default: // sort para columnas que el dato se muestra directamente
            return data.sort(function (a, b) {
              return (sort.direction == "asc" ? 1 : -1) * ((a[sort.active] > b[sort.active]) ? 1 : ((b[sort.active] > a[sort.active]) ? -1 : 0));
            });
        }
      }
      console.log(data,'asdfasdf');
      
      return data; // retorna el data ordenado según el sort
    };
  }

  // get todas las propieades de un objeto (y sus sub objetos) en un objeto plano
  flattenObject = function (ob) {
    var toReturn = {};

    for (var i in ob) {
      if (!ob.hasOwnProperty(i)) continue;

      if ((typeof ob[i]) == 'object') {
        var flatObject = this.flattenObject(ob[i]);
        for (var x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }

    return toReturn;
  };

  onFiltro(filterValue: string = '') { // filtro nativo de MatTableDataSource
    filterValue = filterValue.trim(); // quitar espacios en blanco
    filterValue = filterValue.toLowerCase(); // MatTableDataSource trabaja por default con lowercase
    this.contactosDataSource.filter = filterValue;
  }

  contactoCreado(evento: any) { // agregar dato creado al listado
    // console.log('Paso');
    // console.log('evento.contacto', evento.contacto);

    if (evento && evento.contacto) {

      let contacto = <Contacto>evento.contacto;
      this.contactos.unshift(new Contacto(
        contacto.apellido,
        contacto.cargo,
        contacto.celularCodigoPais,
        contacto.celularCodigoArea,
        contacto.celularNumero,
        contacto.email,
        <Entidad>{
          // IdEntidad: contacto.entidad.IdEntidad,
          // razonSocial: contacto.entidad.razonSocial
        },
        contacto.examen,
        contacto.fechaAlta,
        contacto.fechaCertificacion,
        contacto.fechaModificacion,
        contacto.usuarioModificacion,
        contacto.dia_nacimiento,
        contacto.mes_nacimiento,
        contacto.fechaUltimaCertificacion,
        contacto.idContacto,
        contacto.interno,
        contacto.kit,
        contacto.nombre,
        contacto.pago,
        contacto.perfil,
        contacto.razonSocial,
        contacto.telefonoCodigoPais,
        contacto.telefonoCodigoArea,
        contacto.telefonoNumero,
        <TipoContacto>{
          IdTipoContacto: contacto.tipoContacto.IdTipoContacto,
          tipoContactoDesc: contacto.tipoContacto.tipoContactoDesc
        },
      ));
      this.contactosDataSource.data = this.contactos;
      this.onChange.emit();
    }
  }

  contactoEliminado(index: any) { // quitar del listado según el index
    this.contactos.splice(index, 1);
    this.contactosDataSource.data = this.contactos;
    this.onChange.emit();
  }

  contactoEditado(index: any, evento: any) { // editar el dato según el index y los datos
    this.contactos[index] = <Contacto>evento.contacto;
    this.contactosDataSource.data = this.contactos;
    this.onChange.emit();
  }

  setContactos(contactos: Contacto[]): void { // actualizar listado
    this.contactos = contactos;
    this.contactosDataSource.data = this.contactos;
    this.onChange.emit();
  }

  setCargando(cargando: boolean = true): void { // cambiar el estado de la barra de cargando
    this.cargando = cargando;
  }
}
